/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Route, Navigate } from 'react-router';
import { NotFoundPage, RequireAuthExternal } from 'sarsaparilla';

import TripPlannerStartContainer from '../src/containers/TripPlannerStartContainer';
import TripContentContainer from '../src/containers/TripContentContainer';

import routesArray from './routesArray';

function RedirectToPlanner() {
    return <Navigate to="/trips/new" />;
}

const Components = {
    TripPlannerStartContainer,
    TripContentContainer,
    RedirectToPlanner,
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        if (route.requireAuth) {
            return (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        <RequireAuthExternal>
                            <Component />
                        </RequireAuthExternal>
                    }
                />
            );
        }
        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    routeComponents.push(<Route path="*" key="notFound" element={<NotFoundPage />} />);

    return routeComponents;
}
